import Page from "../pages/Page";
import {getApi, handleError, logout} from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import $ from "jquery";
import {gotoDefault, getParameterValue, navigateTo} from "~/utils";
import {validatePassword, comparePassword} from "~/utils/password";

class ReimpostaPassword extends Page {

    private theForm: HTMLFormElement = document.getElementById("form-reimpostapassword") as HTMLFormElement;

        constructor() {
            super("reimpostapassword", "Reimposta password");
        }

    pageStart(): Promise<void> {
        const that = this;
        that.addValidation();

        $("#btnReimpostaPassword").on("click", function (e) {
            e.preventDefault();
            that.handleFormSubmit();
        });

        return Promise.resolve();
    }

    private addValidation(): void { 
        const form = this.theForm;

        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        // Validatore per l'email
        const emailValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const email = $(inputElement).val() as string;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(email);

            return {
                ok: isValid,
                error: isValid ? "" : "Formato email non valido" // TODO: i18n
            };
        };
        
        // Validatore per la password
        const passwordValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const password = $(inputElement).val() as string;
            const isValid = validatePassword(password);

            return {
                ok: isValid.ok,
                error: isValid.ok ? "" : "Formato non corretto" // TODO: i18n
            };
        };

        // Validatore per il confronto delle password
        const compareValidator = (inputElement: HTMLInputElement, compareElement: HTMLInputElement): validation.ValidationResult => {
            const confermaPassword = $(inputElement).val() as string;
            const password = $(compareElement).val() as string;
            const isValid = comparePassword(password, confermaPassword);

            return {
                ok: isValid.ok,
                error: isValid.ok ? "" : "Le password non corrispondono" // TODO: i18n
            };
        };

        const validaEmail = () => {
            validation.validate("txtEmail", emailValidator);
        };
        const validaPassword = () => {
            validation.validate("password-lostpassword", passwordValidator);
        };

        // Funzione per confrontare due campi password
        const comparaPassword = (passwordFieldId: string, confirmPasswordFieldId: string) => {
            const passwordInput = document.getElementById(passwordFieldId) as HTMLInputElement;
            const confirmPasswordInput = document.getElementById(confirmPasswordFieldId) as HTMLInputElement;

            if (passwordInput && confirmPasswordInput) {
                validation.validate(confirmPasswordFieldId, (inputElement) =>
                    compareValidator(inputElement, passwordInput)
                );
            }
        };

        // Imposta i validatori sui campi
        validation.setValidatorOnInput("txtEmail", emailValidator);
        validation.setValidatorOnInput("password-lostpassword", passwordValidator);
        validation.setValidatorOnInput("confirmpsw-lostpassword", (inputElement) =>
            compareValidator(inputElement, document.getElementById("password-lostpassword") as HTMLInputElement)
        );

        // Validazione al submit
        this.onSubmitValidator = async () => {
            validaEmail();
            validaPassword();
            comparaPassword("password-lostpassword", "confirmpsw-lostpassword");
        };
    }

    private onSubmitValidator: () => void = async () => {
    }

    private async handleFormSubmit(): Promise<void> {
        console.log("🔍 handleFormSubmit START");

        $("#waitmessage").html("").toggleClass("d-none fade", true);

        // Validazione del form
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            console.warn("❌ Form validation failed");
            this.theForm.classList.add('was-validated');
            return;
        }

        const email = $("#txtEmail").val() as string;
        const password = $("#password-lostpassword").val() as string;
        const token = $("#code").val() as string;
        //const token = this.getToken();

        console.log("📧 Email:", email);
        console.log("🔑 Token presente:", !!token);
        console.log("🔑 Token length:", token?.length);
        console.log("📝 Password length:", password?.length);

        // Verifica che tutti i parametri siano presenti
        if (!email || !password || !token) {
            console.error("❌ Parametri mancanti:", { email: !!email, password: !!password, token: !!token });
            $("#waitmessage")
                .html('<div class="alert alert-danger">Dati incompleti. Verifica email, password e token.</div>')
                .toggleClass("d-none fade", false);
            return;
        }

        let _ = this.spinner.spin();
        try {
            console.log("🚀 Calling API resetPassword...");
            console.log("📦 Request params:", { email, password: password, passwordLength: password.length, token: token, tokenLength: token.length });
            const result = await getApi().resetPassword(email, password, token);
            console.log("✅ API Response:", result);

            UI.confirmOneButton(" ", "La tua password è stata reimpostata correttamente.", "", function (result) {
                if (result) {
                    const returnUrlParam = getParameterValue("returnUrl");
                    if (returnUrlParam && returnUrlParam.length > 0) {
                        _ = navigateTo(decodeURIComponent(returnUrlParam));
                    } else {
                        _ = gotoDefault();
                    }
                }
            }).then();

        } catch (e) {
            console.error("❌ API Error:", e);
            console.error("❌ Error details:", JSON.stringify(e));
            console.error("❌ Error stack:", e instanceof Error ? e.stack : "N/A");

            let errHtml = handleError(e);
            $("#waitmessage")
                .html(errHtml)
                .toggleClass("d-none fade", false);
        } finally {
            console.log("🏁 handleFormSubmit END");
            this.spinner.stop();
        }
    }

}

export default ReimpostaPassword;